module.exports = __webpack_public_path__ + "static/media/cloud_logo.c27638b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/details/imgs/cloud_logo.png
// module id = 1156
// module chunks = 0